import Button from "components/common/Button/Button";
import { Title } from "components/common/Formatting";
import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";
import context from "lib/stores/context";
import { RadixTooltip } from "components/common/Tooltip/RadixTooltip";
import styles from "./index.module.scss";
import SummaryStatistic from "./SummaryStatistic";
import TooltipButton from "components/common/Tooltip/TooltipButton";
import classNames from "classnames";
import { useSnapshot } from "valtio";

const RegionSummaryContent = () => {
  const { regions, metadata } = useSnapshot(apiData);
  const { activeRegion } = useSnapshot(context);
  const { year } = useSnapshot(mapData);
  const region = regions.find(region => {
    return region.id === activeRegion;
  });

  const formatValue = (value, type = "") => {
    if (!value) {
      return "-";
    }
    if (type === "prevalence") {
      return Math.round(value * 10) / 10;
    } else {
      return Math.round(value);
    }
  };

  return (
    <div className={classNames(styles["region-summary-content-container"])}>
      <Title className={classNames(styles["summary-title"], styles["region-summary-title"], "uppercase")} element="h1" variant="lg">
        {region.name}
      </Title>
      <div className={styles["summary-statistics-row"]}>
        <SummaryStatistic
          label="Prevalence"
          value={formatValue(region[year]?.prevalence, "prevalence")}
          content={metadata.labels.prevalence_tooltip}
        />
        <SummaryStatistic
          label="Vulnerability"
          value={formatValue(region[year]?.vulnerability)}
          content={metadata.labels.vulnerability_tooltip}
        />
        <SummaryStatistic
          label="Gov Response"
          value={formatValue(region[year]?.gov_response)}
          content={metadata.labels.gov_response_tooltip}
        />
      </div>
      <button
        type="button"
        className={classNames(styles["prevalence-button"], styles["summary-content-button-root-styles"], styles["is-variant-explore"])}
        onClick={() => {
          try {
            window.location.hash = regions[activeRegion - 1].explore_region_data_url;
            window.history.pushState(null, null, window.location.href);
          } catch (error) {
            // console.log(error);
          }
        }}
      >
        Explore Region Data
      </button>
    </div>
  );
};

export default RegionSummaryContent;
